import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import { Eyebrow, SectionLabel } from "@/components/Eyebrow";
import { api } from "@/lib/api";

export default function Resources() {
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { (async () => {
    try { const res = await api.get("/guides"); setGuides(res.data || []); } catch {} finally { setLoading(false); }
  })(); }, []);

  const florida = guides.filter((g) => g.category === "florida_transfer").sort((a, b) => {
    // Forbes guide (#16) surfaces first
    if (a.number === 16) return -1;
    if (b.number === 16) return 1;
    return a.number - b.number;
  });
  const grad = guides.filter((g) => g.category === "graduate_pathways").sort((a, b) => a.number - b.number);

  return (
    <Layout>
      <SEO
        title="Resources — Cornerstone Guides on Florida Transfer & Grad Pathways"
        description="Cornerstone guides on the Florida transfer system, the Forbes New Ivies, and graduate pathways (law, medical, PhD). Published essays by Taimur Ahmed."
        canonical="/resources"
      />
      <section className="border-b border-stone/30 bg-bone" data-testid="resources-page">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 pt-20 lg:pt-28 pb-16">
          <Eyebrow>Resources · Guides</Eyebrow>
          <h1 className="font-serif font-medium text-4xl sm:text-5xl lg:text-[4.75rem] text-ink leading-[1.04] tracking-tightest mt-5">The library.</h1>
          <p className="mt-7 text-ink-soft text-base sm:text-lg max-w-2xl leading-relaxed">
            Cornerstone guides on the Florida transfer system, the Forbes New Ivies, and graduate pathways. Some are in editorial; published versions are linked.
          </p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-5 sm:px-8 py-16">
        <SectionLabel index="01" label="Florida Transfer" />
        {loading ? <div className="mt-8 text-ink-soft text-sm">Loading…</div> : (
          <div className="mt-8 border-t border-l border-stone/40 grid sm:grid-cols-2" data-testid="resources-florida-list">
            {florida.map((g) => (
              <Link key={g.slug} to={`/resources/${g.slug}`} className="border-r border-b border-stone/40 bg-bone p-6 hover:bg-bone-dim transition-colors group" data-testid={`guide-card-${g.slug}`}>
                <div className="text-[10px] uppercase tracking-[0.24em] text-brass">Guide {String(g.number).padStart(2, "0")} {g.number === 16 && <span className="ml-2 text-ivy">· Featured</span>}</div>
                <h3 className="font-serif font-medium text-xl text-ink mt-2 leading-tight tracking-tight group-hover:text-ivy transition-colors">{g.title}</h3>
                <p className="text-sm text-ink-soft mt-3 leading-relaxed">{g.excerpt}</p>
                {g.placeholder && <span className="inline-block mt-3 text-[10px] uppercase tracking-[0.2em] text-stone">Outline — coming soon</span>}
              </Link>
            ))}
          </div>
        )}
      </section>

      <section className="max-w-5xl mx-auto px-5 sm:px-8 py-16">
        <SectionLabel index="02" label="Graduate Pathways" />
        {!loading && (
          <div className="mt-8 border-t border-l border-stone/40 grid sm:grid-cols-3" data-testid="resources-grad-list">
            {grad.map((g) => (
              <Link key={g.slug} to={`/resources/${g.slug}`} className="border-r border-b border-stone/40 bg-bone p-6 hover:bg-bone-dim transition-colors group">
                <div className="text-[10px] uppercase tracking-[0.24em] text-brass">Guide {String(g.number).padStart(2, "0")}</div>
                <h3 className="font-serif font-medium text-xl text-ink mt-2 leading-tight tracking-tight group-hover:text-ivy transition-colors">{g.title}</h3>
                <p className="text-sm text-ink-soft mt-3 leading-relaxed">{g.excerpt}</p>
              </Link>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
